import React from 'react';
import { Textarea } from './FormControls';
import { useAppConfig } from '../../hooks/useAppConfig';

interface PromptTextareaProps extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'maxLength'> {
  maxLength?: number;
  showCounter?: boolean;
}

export function PromptTextarea({
  maxLength,
  showCounter = true,
  value,
  style,
  ...props
}: PromptTextareaProps) {
  const { config } = useAppConfig();
  const effectiveMaxLength = maxLength ?? config?.max_input_chars;
  const currentLength = typeof value === 'string' ? value.length : 0;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', ...style }}>
      <Textarea
        value={value}
        maxLength={effectiveMaxLength}
        style={{ width: '100%', minHeight: '80px', flex: 1 }}
        {...props}
      />
      {showCounter && effectiveMaxLength && (
        <div style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-secondary)', textAlign: 'right', marginTop: '4px' }}>
          {currentLength} / {effectiveMaxLength} characters
        </div>
      )}
    </div>
  );
}
